export const options = [
  "Algebra",
  "Geometry",
  "Algebraic Structures",
  "Analysis",
  "Applied Mathematics",
  "Calculus",
  "Combinatorics",
  "Differential Equations",
  "Differential Geometry",
  "Element Methods",
  "Graph Theory",
  "Logic",
  "Mathematical Finance",
  "Mathematical Modeling",
  "Mathematics",
  "Methods",
  "Modeling",
  "Numerical Algebra",
  "Numerical Linear",
  "Operations Research",
  "Optimization",
  "Partial Differential",
  "Probability",
  "Series Analysis",
  "Stochastic Calculus",
  "Stochastic Processes",
  "Theory",
  "Time Series",
  "Topology",
  "Wavelets",
  "Biology",
  "Computational Biology",
  "Fluid Dynamics",
  "Physics",
  "Signal Processing",
  "Simulation",
  "Engineering",
  "Structures",
  "Computer Algebra",
  "Data Science",
  "Computational Dynamics",
  "Computational Finance",
  "Computational Mathematics",
  "Computational Statistics",
  "High-Performance Computing",
  "Machine Learning",
  "Mathematical Software",
  "Programming",
  "Software",
];
